import React, { useState } from "react";
// import Cookies from "universal-cookie";
import GoogleButton from "./GoogleButton";
// import { loginUser, registerUser } from "../redux/slices/userSlice";
// import { useDispatch } from "react-redux";
interface LoginProps {
  ModalOpen: boolean;
  closeModal: () => void;
  url: string;
  isDarkMode: boolean;
  img: string;
}
// import { Dispatch } from "@reduxjs/toolkit";

// import { AppDispatch } from "../redux/slices/types/types";
export const Login = ({
  ModalOpen,
  closeModal,
  url,
  isDarkMode,
  img,
}: LoginProps) => {
  // const [isLoginMode, setIsLoginMode] = useState(true);
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");

  // const [name, setName] = useState("");
  // const [mobile, setMobile] = useState("");
  // const [confirmPassword, setConfirmPassword] = useState("");
  // const [termsAccepted, setTermsAccepted] = useState(false);
  // const [loading] = useState(false);
  // const [error, setError] = useState<string | null>(null);
  // const [successMessage, setSuccessMessage] = useState<string | null>(null);
  // // const cookies = new Cookies();
  // const toggleMode = () => setIsLoginMode(!isLoginMode);
  // const dispatch: any = useDispatch(); // Typing the dispatch with AppDispatch

  // const handleLogin = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   dispatch(loginUser(url, email, password));
  // };

  // const handleRegister = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   dispatch(registerUser(url, name, email, mobile, confirmPassword));
  // };

  return (
    <div
      className={`${isDarkMode ? "bg-[#2e2e2e] text-[#ffff]" : "bg-[#ffff] text-black"
        }`}
    >
      {ModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 transition-opacity duration-75 ease-in-out ">
          <div
            className={`relative ${isDarkMode ? "bg-[#2e2e2e]" : "bg-white"
              } p-4 sm:p-6 lg:p-8 rounded-lg max-w-sm sm:max-w-md w-full shadow-lg transform transition-all duration-500 ease-in-out `}
          >
            <button
              onClick={closeModal}
              className={` absolute top-1 right-3 text-3xl ${isDarkMode ? " text-[#ffff]" : " text-black"
                }`}
            >
              &times;
            </button>
            <img
              className="h-20 w-20 mx-auto animate-fadeIn"
              src={img}
              alt="Logo"
            />
            <h1
              className={`mt-3 text-xl sm:text-2xl font-semibold capitalize text-center ${isDarkMode ? "text-[#ffff]" : "text-black"
                }`}
            >
              {/* {isLoginMode ? "Sign In" : "Sign Up"} */}
              Sign In
            </h1>
{/* 
            <form onSubmit={isLoginMode ? handleLogin : handleRegister}>
              {!isLoginMode && (
                <>
                  <div className="relative flex items-center mt-4">
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="block w-full py-2 text-gray-700 bg-white border rounded-lg px-3 sm:px-6 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
                      placeholder="Full Name"
                      required
                    />
                  </div>

                  <div className="relative flex items-center mt-4">
                    <input
                      type="tel"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                      className="block w-full py-2 text-gray-700 bg-white border rounded-lg px-3 sm:px-6 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
                      placeholder="Mobile Number"
                      required
                    />
                  </div>

                  <div className="relative flex items-center mt-4">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="block w-full py-2 text-gray-700 bg-white border rounded-lg px-3 sm:px-6 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
                      placeholder="Email address"
                      required
                    />
                  </div>

                  <div className="relative flex items-center mt-4">
                    <input
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="block w-full px-3 sm:px-6 py-2 text-gray-700 bg-white border rounded-lg dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
                      placeholder="Password"
                      required
                    />
                  </div>

                  <div className="relative flex items-center mt-4">
                    <input
                      type="password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      className="block w-full py-2 text-gray-700 bg-white border rounded-lg px-3 sm:px-6 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
                      placeholder="Confirm Password"
                      required
                    />
                  </div>

                  <div className="mt-4">
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        checked={termsAccepted}
                        onChange={() => setTermsAccepted(!termsAccepted)}
                        className="form-checkbox cursor-pointer"
                      />
                      <span className="ml-2 text-sm text-gray-600 dark:text-gray-300">
                        I accept the{" "}
                        <button className="text-blue-500 hover:underline">
                          terms and conditions
                        </button>
                      </span>
                    </label>
                  </div>
                </>
              )}

              {isLoginMode && (
                <>
                  <div className="relative flex items-center mt-4">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="block w-full py-2 text-gray-700 bg-white border rounded-lg px-3 sm:px-6 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
                      placeholder="Email address"
                      required
                    />
                  </div>

                  <div className="relative flex items-center mt-4">
                    <input
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="block w-full px-3 sm:px-6 py-2 text-gray-700 bg-white border rounded-lg dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
                      placeholder="Password"
                      required
                    />
                  </div>
                </>
              )}

              <div className="mt-6">
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full px-6 py-2 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-500 rounded-lg hover:bg-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
                >
                  {loading
                    ? isLoginMode
                      ? "Logging in..."
                      : "Registering..."
                    : isLoginMode
                      ? "Login"
                      : "Register"}
                </button>
              </div>
            </form> */}

            {/* <div className="flex items-center justify-center mt-2">
              <hr className="w-1/4" />
              <span className="mx-2 text-gray-500">or</span>
              <hr className="w-1/4" />
            </div> */}
            <div className="">
              <GoogleButton
                url={url}
                onClose={function (): void {
                  throw new Error("Function not implemented.");
                }}
              />
            </div>
            {/* <div className="mt-2 text-center">
              <button
                onClick={toggleMode}
                className="text-sm text-blue-500 hover:underline"
              >
                {isLoginMode
                  ? "Don't have an account? Sign Up"
                  : "Already have an account? Sign In"}
              </button>
            </div> */}

            {/* {error && (
              <p className="mt-2 w-full  text-center text-red-500">{error}</p>
            )}
            {successMessage && (
              <p className="mt-2 text-center text-green-500">
                {successMessage}
              </p>
            )} */}
          </div>
        </div>
      )}
    </div>
  );
};
